import React from 'react';
import {
  Paper, Grid, TextField, InputAdornment, IconButton, FormControl, InputLabel, Select, MenuItem, Tooltip, Button, Collapse, Box
} from '@mui/material';
import {
  Search as SearchIcon, Clear as ClearIcon, FilterList as FilterListIcon, FilterAltOff as FilterAltOffIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const FilterBar = ({
  filters,
  onFilterChange,
  onDateChange,
  onResetFilters,
  uniqueCreators,
  showFilters,
  onToggleFilters,
  isMobile,
  t
}) => {
  const theme = useTheme();

  return (
    <Paper sx={{ p: 2, mb: 2.5, borderRadius: theme.shape.borderRadius }} elevation={0} variant="outlined">
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            name="searchTerm"
            label={t("searchEntries")}
            variant="outlined"
            size="small"
            value={filters.searchTerm}
            onChange={onFilterChange}
            placeholder={t("searchBetriebstageBuchPlaceholder", "Date (dd.mm.yyyy, dd.mm, yyyy), issuer name...")}
            helperText={t("searchBetriebstageBuchHelp", "Search by date, issuer name, or any text")}
            InputProps={{
              startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" color="action" /></InputAdornment>,
              endAdornment: filters.searchTerm && <InputAdornment position="end"><IconButton size="small" onClick={() => onFilterChange({ target: { name: 'searchTerm', value: '' } })}><ClearIcon fontSize="small" /></IconButton></InputAdornment>
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={isMobile ? 4 : 3}>
          <FormControl fullWidth size="small" sx={{ minWidth: 180 }}>
            <InputLabel>{t("status")}</InputLabel>
            <Select name="status" value={filters.status} label={t("status")} onChange={onFilterChange} sx={{ minWidth: 180 }}>
              <MenuItem value="">{t("allStatuses")}</MenuItem>
              <MenuItem value="approved">{t("approved")}</MenuItem>
              <MenuItem value="pending">{t("pending")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={'auto'} container justifyContent="flex-end" alignItems="center" spacing={1} sx={{ ml: 'auto' }}>
          <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
            <Grid item xs={12}>
              <IconButton onClick={onToggleFilters} color={showFilters ? "primary" : "default"} sx={{ width: '100%' }}>
                <FilterListIcon /> {showFilters ? t('hideFilters') : t('showFilters')}
              </IconButton>
            </Grid>
          </Box>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Grid item>
              <Tooltip title={t('toggleFilters')}>
                <IconButton onClick={onToggleFilters} color={showFilters ? "primary" : "default"}>
                  <FilterListIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Box>
          <Grid item>
            <Button variant="text" onClick={onResetFilters} size={isMobile ? "small" : "medium"} startIcon={<FilterAltOffIcon />}>
              {t("reset")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
     
    </Paper>
  );
};

export default FilterBar;
